"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DialogInnerContentStyle = exports.DialogContentStyle = exports.DialogTitleStyle = exports.DialogStyle = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _base = _interopRequireDefault(require("../../style/themes/base"));

var _form = require("../form/form.style");

var _heading = require("../heading/heading.style");

var _iconButton = _interopRequireDefault(require("../icon-button/icon-button.style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const dialogSizes = {
  auto: "auto",
  "extra-small": "300px",
  small: "380px",
  "medium-small": "540px",
  medium: "750px",
  "medium-large": "850px",
  large: "960px",
  "extra-large": "1080px"
};
const HORIZONTAL_PADDING = 35;
const CONTENT_BOTTOM_PADDING = 30;
const DialogStyle = _styledComponents.default.div`
  background-color: #f2f5f6;
  box-shadow: ${({
  theme
}) => theme.shadows.depth3};
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 50%;
  max-height: ${({
  topMargin
}) => `calc(100vh - ${topMargin}px)`};

  &:focus {
    outline: none;
  }

  ${({
  size
}) => size && (0, _styledComponents.css)`
      width: ${dialogSizes[size]};

      // IE10+ fix (caters for scrollbar width)
      @media screen and (-ms-high-contrast: active),
        screen and (-ms-high-contrast: none) {
        width: $size - 16;
      }
    `}

  ${({
  dialogHeight
}) => dialogHeight && (0, _styledComponents.css)`
      height: ${dialogHeight}px;
    `};

  ${_form.StyledForm} {
    height: 100%;
    padding-bottom: 0px;
    box-sizing: border-box;
  }

  ${_form.StyledFormFooter}.sticky {
    margin-left: -${HORIZONTAL_PADDING}px;
    bottom: -${CONTENT_BOTTOM_PADDING}px;
    margin-bottom: -${CONTENT_BOTTOM_PADDING}px;
    width: calc(100% + ${2 * HORIZONTAL_PADDING}px);
    position: sticky;
    padding-left: ${HORIZONTAL_PADDING}px;
    padding-right: ${HORIZONTAL_PADDING}px;
  }

  > ${_iconButton.default} {
    margin: 0;
    position: absolute;
    right: 33px;
    top: 32px;
    z-index: 1;

    &:hover {
      color: #255bc7;
    }
  }
`;
exports.DialogStyle = DialogStyle;
const DialogTitleStyle = _styledComponents.default.div`
  padding: 23px ${HORIZONTAL_PADDING}px 0;
  border-bottom: 1px solid #ccd6db;
  ${({
  showCloseIcon
}) => showCloseIcon && "padding-right: 85px"};

  ${_heading.StyledHeaderContent} {
    align-items: baseline;
  }

  ${_heading.StyledHeading} {
    margin-bottom: 20px;

    ${_heading.StyledHeadingTitle} {
      color: ${({
  theme
}) => theme.text.color};
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
      padding: ${({
  hasSubtitle
}) => !hasSubtitle && "4px 0px"};
    }
  }
`;
exports.DialogTitleStyle = DialogTitleStyle;
const DialogContentStyle = _styledComponents.default.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  width: 100%;
  flex: 1;
  padding: 0px ${HORIZONTAL_PADDING}px ${CONTENT_BOTTOM_PADDING}px;
`;
exports.DialogContentStyle = DialogContentStyle;
const DialogInnerContentStyle = _styledComponents.default.div`
  padding-top: 20px;
  position: relative;
  flex: 1;
`;
exports.DialogInnerContentStyle = DialogInnerContentStyle;
DialogTitleStyle.defaultProps = {
  theme: _base.default
};
DialogStyle.defaultProps = {
  theme: _base.default
};